var _g, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullScreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4926_30953)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 60,
    height: 60,
    rx: 12,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.25 17.875H20.375C19.3395 17.875 18.5 18.7145 18.5 19.75V25.375C18.5 26.4105 19.3395 27.25 20.375 27.25C21.4105 27.25 22.25 26.4105 22.25 25.375V21.625H28.25C29.2855 21.625 30.125 20.7855 30.125 19.75C30.125 18.7145 29.2855 17.875 28.25 17.875Z",
    fill: "#61739F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.875 17.875H35C33.9645 17.875 33.125 18.7145 33.125 19.75C33.125 20.7855 33.9645 21.625 35 21.625H41V25.375C41 26.4105 41.8395 27.25 42.875 27.25C43.9105 27.25 44.75 26.4105 44.75 25.375V19.75C44.75 18.7145 43.9105 17.875 42.875 17.875Z",
    fill: "#61739F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.875 33.25C41.8395 33.25 41 34.0895 41 35.125V40.375H35C33.9645 40.375 33.125 41.2145 33.125 42.25C33.125 43.2855 33.9645 44.125 35 44.125H42.875C43.9105 44.125 44.75 43.2855 44.75 42.25V35.125C44.75 34.0895 43.9105 33.25 42.875 33.25Z",
    fill: "#7B86A0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.25 40.375H22.25V35.125C22.25 34.0895 21.4105 33.25 20.375 33.25C19.3395 33.25 18.5 34.0895 18.5 35.125V42.25C18.5 43.2855 19.3395 44.125 20.375 44.125H28.25C29.2855 44.125 30.125 43.2855 30.125 42.25C30.125 41.2145 29.2855 40.375 28.25 40.375Z",
    fill: "#7B86A0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4926_30953",
    x: 0,
    y: 0,
    width: 62,
    height: 62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4926_30953"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4926_30953",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullScreen);
export default __webpack_public_path__ + "static/media/full_screen.3f06a3609cb797b52d884aa154f50cbc.svg";
export { ForwardRef as ReactComponent };